import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default class DiagnosticosV2 extends Component{

  state = {
    diagnosticos:[],
    loading: false
  }
  
  componentDidMount() {
    
    // let id_interval = setInterval(() => {

      const { unidad_medica_user, periodo, backend } = this.props;

      fetch(`${backend}/diagnosticos/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
        // debugger
          this.setState({
            diagnosticos: data.data,
            loading:true
          })
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener información de los diagnósticos.",
          });
          message.destroy()
      });

    // }, 3000);
  }


  render(){

    const { diagnosticos, loading } = this.state;

    return(
      loading ? 
        <TableContainer component={Paper}>
          <Table 
          sx={{ 
            // minWidth: 700 
            // maxWidth:700
          }} 
          size="small" aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Diagnóstico</StyledTableCell>
                <StyledTableCell align="center">No. de casos</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {diagnosticos.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.value}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        : <Spin size="small" />
    );
  }
}


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    backgroundColor:'rgb(36, 98, 151)',
    color: theme.palette.common.white,
    fontWeight:'bold',
    fontSize:17
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));